import styled from "styled-components"

export const HomeContainer = styled.main`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
`
